import React from 'react';
import classes from '../Viewer.module.scss';
import { CloseCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import ReactPlayer from 'react-player';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useAppSelector } from 'store/hook';
import { audioExtensions } from 'helpers/filesExtensions';

//@ts-ignore
const storageType = window.REACT_APP_STORAGE_TYPE !== 'REPLACE_REACT_APP_STORAGE_TYPE' ? window.REACT_APP_STORAGE_TYPE : process.env.REACT_APP_STORAGE_TYPE || 'S3';

type VideoViewerProps = {
  url: any;
  onClose?: () => void;
  downloadDocument?: () => void;
  isStatic?: boolean;
}

const VideoViewer = ({url, onClose, downloadDocument, isStatic}: VideoViewerProps) => {
  const { documentExtention } = useAppSelector(state => state.viewer);
  
  const { t } = useTranslation();

  const isAudio = audioExtensions.includes(documentExtention)

  const configPlayer = storageType?.toLowerCase() === 'local' ? {
    file: {
      forceDASH: true,
      forceAudio: isAudio,
    }
  } : {
    file: {
      forceAudio: isAudio,
    }
  };
    
  return (
    <div className={cn(classes.videoViewer, isStatic ? classes.staticVideo : 'null')}>
      { onClose && <CloseCircleOutlined className={classes.close} onClick={onClose} /> }
      { downloadDocument &&
        <Button onClick={downloadDocument} className={classes.download} icon={<DownloadOutlined />}>
          {t('templink.download')}
        </Button>
      }

      <ReactPlayer
        playing
        controls
        style={{background: 'white'}}
        width={isAudio ? '90%' : '100%'}
        height={isAudio ? '50px' : '100%'}
        url={url}
        config={configPlayer}
      />
   </div>
  );
}

export default VideoViewer;
